export interface AttendeeData {
  id: string
  name: string
  role: string
  company: string
  interests: string[]
  profileImage: string
  email: string
  source: 'exhibitor' | 'meeting'
  matchScore?: number
}

// Static list of 110 networking attendees
// These are generated once and remain consistent across all builds
export const attendees: AttendeeData[] = [
  // Founder/Owner tier (11 attendees)
  {
    id: 'attendee-0',
    name: 'Sarah Smith',
    role: 'Founder',
    company: 'Fitness First',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=1',
    email: 'sarah.smith@fitnessfirst.com',
    source: 'exhibitor',
    matchScore: 95,
  },
  {
    id: 'attendee-1',
    name: 'Michael Johnson',
    role: 'Co-Founder',
    company: 'GymNation',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=2',
    email: 'michael.johnson@gymnation.com',
    source: 'exhibitor',
    matchScore: 92,
  },
  {
    id: 'attendee-2',
    name: 'Emma Williams',
    role: 'Owner',
    company: 'Enhance Fitness',
    interests: ['Fitness', 'Wellness'],
    profileImage: 'https://i.pravatar.cc/150?img=3',
    email: 'emma.williams@enhancefitness.com',
    source: 'exhibitor',
    matchScore: 90,
  },
  {
    id: 'attendee-3',
    name: 'James Brown',
    role: 'Founder',
    company: 'Anytime Fitness',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=4',
    email: 'james.brown@anytimefitness.com',
    source: 'exhibitor',
    matchScore: 88,
  },
  {
    id: 'attendee-4',
    name: 'Olivia Jones',
    role: 'Co-Founder',
    company: 'Matrix Fitness',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=5',
    email: 'olivia.jones@matrixfitness.com',
    source: 'exhibitor',
    matchScore: 87,
  },
  {
    id: 'attendee-5',
    name: 'David Garcia',
    role: 'Owner',
    company: 'Technogym',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=6',
    email: 'david.garcia@technogym.com',
    source: 'exhibitor',
    matchScore: 85,
  },
  {
    id: 'attendee-6',
    name: 'Sophia Miller',
    role: 'Founder',
    company: 'MyProtein',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=7',
    email: 'sophia.miller@myprotein.com',
    source: 'exhibitor',
    matchScore: 84,
  },
  {
    id: 'attendee-7',
    name: 'John Davis',
    role: 'Co-Founder',
    company: 'Optimum Nutrition',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=8',
    email: 'john.davis@optimumnutrition.com',
    source: 'exhibitor',
    matchScore: 82,
  },
  {
    id: 'attendee-8',
    name: 'Isabella Rodriguez',
    role: 'Owner',
    company: 'Lululemon',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=9',
    email: 'isabella.rodriguez@lululemon.com',
    source: 'exhibitor',
    matchScore: 81,
  },
  {
    id: 'attendee-9',
    name: 'Robert Martinez',
    role: 'Founder',
    company: 'Nike',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=10',
    email: 'robert.martinez@nike.com',
    source: 'exhibitor',
    matchScore: 80,
  },
  {
    id: 'attendee-10',
    name: 'Mia Hernandez',
    role: 'Owner',
    company: 'Fitness First',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=11',
    email: 'mia.hernandez@fitnessfirst.com',
    source: 'exhibitor',
    matchScore: 79,
  },

  // C-Suite tier (17 attendees)
  {
    id: 'attendee-11',
    name: 'William Lopez',
    role: 'CEO',
    company: 'GymNation',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=12',
    email: 'william.lopez@gymnation.com',
    source: 'exhibitor',
    matchScore: 78,
  },
  {
    id: 'attendee-12',
    name: 'Charlotte Gonzalez',
    role: 'Chief Executive Officer',
    company: 'Enhance Fitness',
    interests: ['Fitness', 'Wellness'],
    profileImage: 'https://i.pravatar.cc/150?img=13',
    email: 'charlotte.gonzalez@enhancefitness.com',
    source: 'exhibitor',
    matchScore: 77,
  },
  {
    id: 'attendee-13',
    name: 'Thomas Wilson',
    role: 'Chief Operating Officer',
    company: 'Anytime Fitness',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=14',
    email: 'thomas.wilson@anytimefitness.com',
    source: 'exhibitor',
    matchScore: 76,
  },
  {
    id: 'attendee-14',
    name: 'Amelia Anderson',
    role: 'Chief Marketing Officer',
    company: 'Matrix Fitness',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=15',
    email: 'amelia.anderson@matrixfitness.com',
    source: 'exhibitor',
    matchScore: 75,
  },
  {
    id: 'attendee-15',
    name: 'Daniel Thomas',
    role: 'Chief Technology Officer',
    company: 'Technogym',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=16',
    email: 'daniel.thomas@technogym.com',
    source: 'exhibitor',
    matchScore: 74,
  },
  {
    id: 'attendee-16',
    name: 'Emily Taylor',
    role: 'President',
    company: 'MyProtein',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=17',
    email: 'emily.taylor@myprotein.com',
    source: 'exhibitor',
    matchScore: 73,
  },
  {
    id: 'attendee-17',
    name: 'Matthew Moore',
    role: 'CEO',
    company: 'Optimum Nutrition',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=18',
    email: 'matthew.moore@optimumnutrition.com',
    source: 'exhibitor',
    matchScore: 72,
  },
  {
    id: 'attendee-18',
    name: 'Ava Jackson',
    role: 'Chief Executive Officer',
    company: 'Lululemon',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=19',
    email: 'ava.jackson@lululemon.com',
    source: 'exhibitor',
    matchScore: 71,
  },
  {
    id: 'attendee-19',
    name: 'Christopher Martin',
    role: 'Chief Operating Officer',
    company: 'Nike',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=20',
    email: 'christopher.martin@nike.com',
    source: 'exhibitor',
    matchScore: 70,
  },
  {
    id: 'attendee-20',
    name: 'Lily Lee',
    role: 'Chief Marketing Officer',
    company: 'Fitness First',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=1',
    email: 'lily.lee@fitnessfirst.com',
    source: 'exhibitor',
    matchScore: 69,
  },
  {
    id: 'attendee-21',
    name: 'Andrew Thompson',
    role: 'Chief Technology Officer',
    company: 'GymNation',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=2',
    email: 'andrew.thompson@gymnation.com',
    source: 'exhibitor',
    matchScore: 68,
  },
  {
    id: 'attendee-22',
    name: 'Grace White',
    role: 'President',
    company: 'Enhance Fitness',
    interests: ['Fitness', 'Wellness'],
    profileImage: 'https://i.pravatar.cc/150?img=3',
    email: 'grace.white@enhancefitness.com',
    source: 'exhibitor',
    matchScore: 67,
  },
  {
    id: 'attendee-23',
    name: 'Joseph Harris',
    role: 'CEO',
    company: 'Anytime Fitness',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=4',
    email: 'joseph.harris@anytimefitness.com',
    source: 'exhibitor',
    matchScore: 66,
  },
  {
    id: 'attendee-24',
    name: 'Chloe Clark',
    role: 'Chief Executive Officer',
    company: 'Matrix Fitness',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=5',
    email: 'chloe.clark@matrixfitness.com',
    source: 'exhibitor',
    matchScore: 65,
  },
  {
    id: 'attendee-25',
    name: 'Ryan Lewis',
    role: 'Chief Operating Officer',
    company: 'Technogym',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=6',
    email: 'ryan.lewis@technogym.com',
    source: 'exhibitor',
    matchScore: 64,
  },
  {
    id: 'attendee-26',
    name: 'Zoe Robinson',
    role: 'Chief Marketing Officer',
    company: 'MyProtein',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=7',
    email: 'zoe.robinson@myprotein.com',
    source: 'exhibitor',
    matchScore: 63,
  },
  {
    id: 'attendee-27',
    name: 'Alexander Walker',
    role: 'Chief Technology Officer',
    company: 'Optimum Nutrition',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=8',
    email: 'alexander.walker@optimumnutrition.com',
    source: 'exhibitor',
    matchScore: 62,
  },

  // Director/VP tier (27 attendees)
  {
    id: 'attendee-28',
    name: 'Hannah Young',
    role: 'Director of Sales',
    company: 'Lululemon',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=9',
    email: 'hannah.young@lululemon.com',
    source: 'exhibitor',
    matchScore: 61,
  },
  {
    id: 'attendee-29',
    name: 'Benjamin Allen',
    role: 'Director of Marketing',
    company: 'Nike',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=10',
    email: 'benjamin.allen@nike.com',
    source: 'exhibitor',
    matchScore: 60,
  },
  {
    id: 'attendee-30',
    name: 'Sophie King',
    role: 'Director of Operations',
    company: 'Fitness First',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=11',
    email: 'sophie.king@fitnessfirst.com',
    source: 'exhibitor',
    matchScore: 59,
  },
  {
    id: 'attendee-31',
    name: 'Jack Wright',
    role: 'VP of Business Development',
    company: 'GymNation',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=12',
    email: 'jack.wright@gymnation.com',
    source: 'exhibitor',
    matchScore: 58,
  },
  {
    id: 'attendee-32',
    name: 'Lucy Scott',
    role: 'VP of Sales',
    company: 'Enhance Fitness',
    interests: ['Fitness', 'Wellness'],
    profileImage: 'https://i.pravatar.cc/150?img=13',
    email: 'lucy.scott@enhancefitness.com',
    source: 'exhibitor',
    matchScore: 57,
  },
  {
    id: 'attendee-33',
    name: 'Oliver Torres',
    role: 'Regional Director',
    company: 'Anytime Fitness',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=14',
    email: 'oliver.torres@anytimefitness.com',
    source: 'exhibitor',
    matchScore: 56,
  },
  {
    id: 'attendee-34',
    name: 'Ella Nguyen',
    role: 'Director of Product',
    company: 'Matrix Fitness',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=15',
    email: 'ella.nguyen@matrixfitness.com',
    source: 'exhibitor',
    matchScore: 55,
  },
  {
    id: 'attendee-35',
    name: 'Henry Hill',
    role: 'Director of Strategy',
    company: 'Technogym',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=16',
    email: 'henry.hill@technogym.com',
    source: 'exhibitor',
    matchScore: 54,
  },
  {
    id: 'attendee-36',
    name: 'Megan Flores',
    role: 'Commercial Director',
    company: 'MyProtein',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=17',
    email: 'megan.flores@myprotein.com',
    source: 'exhibitor',
    matchScore: 53,
  },
  {
    id: 'attendee-37',
    name: 'Samuel Green',
    role: 'Director of Sales',
    company: 'Optimum Nutrition',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=18',
    email: 'samuel.green@optimumnutrition.com',
    source: 'exhibitor',
    matchScore: 52,
  },
  {
    id: 'attendee-38',
    name: 'Natalie Adams',
    role: 'Director of Marketing',
    company: 'Lululemon',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=19',
    email: 'natalie.adams@lululemon.com',
    source: 'exhibitor',
    matchScore: 51,
  },
  {
    id: 'attendee-39',
    name: 'Lucas Nelson',
    role: 'Director of Operations',
    company: 'Nike',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=20',
    email: 'lucas.nelson@nike.com',
    source: 'exhibitor',
    matchScore: 50,
  },
  {
    id: 'attendee-40',
    name: 'Victoria Baker',
    role: 'VP of Business Development',
    company: 'Fitness First',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=1',
    email: 'victoria.baker@fitnessfirst.com',
    source: 'exhibitor',
    matchScore: 49,
  },
  {
    id: 'attendee-41',
    name: 'Ethan Hall',
    role: 'VP of Sales',
    company: 'GymNation',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=2',
    email: 'ethan.hall@gymnation.com',
    source: 'exhibitor',
    matchScore: 48,
  },
  {
    id: 'attendee-42',
    name: 'Rachel Rivera',
    role: 'Regional Director',
    company: 'Enhance Fitness',
    interests: ['Fitness', 'Wellness'],
    profileImage: 'https://i.pravatar.cc/150?img=3',
    email: 'rachel.rivera@enhancefitness.com',
    source: 'exhibitor',
    matchScore: 47,
  },
  {
    id: 'attendee-43',
    name: 'Nathan Campbell',
    role: 'Director of Product',
    company: 'Anytime Fitness',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=4',
    email: 'nathan.campbell@anytimefitness.com',
    source: 'exhibitor',
    matchScore: 46,
  },
  {
    id: 'attendee-44',
    name: 'Lauren Mitchell',
    role: 'Director of Strategy',
    company: 'Matrix Fitness',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=5',
    email: 'lauren.mitchell@matrixfitness.com',
    source: 'exhibitor',
    matchScore: 45,
  },
  {
    id: 'attendee-45',
    name: 'Adam Carter',
    role: 'Commercial Director',
    company: 'Technogym',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=6',
    email: 'adam.carter@technogym.com',
    source: 'exhibitor',
    matchScore: 44,
  },
  {
    id: 'attendee-46',
    name: 'Jessica Roberts',
    role: 'Director of Sales',
    company: 'MyProtein',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=7',
    email: 'jessica.roberts@myprotein.com',
    source: 'exhibitor',
    matchScore: 43,
  },
  {
    id: 'attendee-47',
    name: 'Dylan Al-Mansoori',
    role: 'Director of Marketing',
    company: 'Optimum Nutrition',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=8',
    email: 'dylan.almansoori@optimumnutrition.com',
    source: 'exhibitor',
    matchScore: 42,
  },
  {
    id: 'attendee-48',
    name: 'Rebecca Al-Hashemi',
    role: 'Director of Operations',
    company: 'Lululemon',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=9',
    email: 'rebecca.alhashemi@lululemon.com',
    source: 'exhibitor',
    matchScore: 41,
  },
  {
    id: 'attendee-49',
    name: 'Connor Al-Zaabi',
    role: 'VP of Business Development',
    company: 'Nike',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=10',
    email: 'connor.alzaabi@nike.com',
    source: 'exhibitor',
    matchScore: 40,
  },
  {
    id: 'attendee-50',
    name: 'Amy Khan',
    role: 'VP of Sales',
    company: 'Fitness First',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=11',
    email: 'amy.khan@fitnessfirst.com',
    source: 'exhibitor',
    matchScore: 39,
  },
  {
    id: 'attendee-51',
    name: 'Jake Patel',
    role: 'Regional Director',
    company: 'GymNation',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=12',
    email: 'jake.patel@gymnation.com',
    source: 'exhibitor',
    matchScore: 38,
  },
  {
    id: 'attendee-52',
    name: 'Nicole Singh',
    role: 'Director of Product',
    company: 'Enhance Fitness',
    interests: ['Fitness', 'Wellness'],
    profileImage: 'https://i.pravatar.cc/150?img=13',
    email: 'nicole.singh@enhancefitness.com',
    source: 'exhibitor',
    matchScore: 37,
  },
  {
    id: 'attendee-53',
    name: 'Mohammed Chen',
    role: 'Director of Strategy',
    company: 'Anytime Fitness',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=14',
    email: 'mohammed.chen@anytimefitness.com',
    source: 'exhibitor',
    matchScore: 36,
  },
  {
    id: 'attendee-54',
    name: 'Fatima Wang',
    role: 'Commercial Director',
    company: 'Matrix Fitness',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=15',
    email: 'fatima.wang@matrixfitness.com',
    source: 'exhibitor',
    matchScore: 35,
  },

  // Head tier (17 attendees)
  {
    id: 'attendee-55',
    name: 'Ahmed Smith',
    role: 'Head of Sales',
    company: 'Technogym',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=16',
    email: 'ahmed.smith@technogym.com',
    source: 'exhibitor',
    matchScore: 78,
  },
  {
    id: 'attendee-56',
    name: 'Aisha Johnson',
    role: 'Head of Marketing',
    company: 'MyProtein',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=17',
    email: 'aisha.johnson@myprotein.com',
    source: 'exhibitor',
    matchScore: 77,
  },
  {
    id: 'attendee-57',
    name: 'Ali Williams',
    role: 'Head of Operations',
    company: 'Optimum Nutrition',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=18',
    email: 'ali.williams@optimumnutrition.com',
    source: 'exhibitor',
    matchScore: 76,
  },
  {
    id: 'attendee-58',
    name: 'Layla Brown',
    role: 'Head of Product',
    company: 'Lululemon',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=19',
    email: 'layla.brown@lululemon.com',
    source: 'exhibitor',
    matchScore: 75,
  },
  {
    id: 'attendee-59',
    name: 'Omar Jones',
    role: 'Head of Sales',
    company: 'Nike',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=20',
    email: 'omar.jones@nike.com',
    source: 'exhibitor',
    matchScore: 74,
  },
  {
    id: 'attendee-60',
    name: 'Noor Garcia',
    role: 'Head of Marketing',
    company: 'Fitness First',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=1',
    email: 'noor.garcia@fitnessfirst.com',
    source: 'exhibitor',
    matchScore: 73,
  },
  {
    id: 'attendee-61',
    name: 'Sarah Miller',
    role: 'Head of Operations',
    company: 'GymNation',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=2',
    email: 'sarah.miller@gymnation.com',
    source: 'exhibitor',
    matchScore: 72,
  },
  {
    id: 'attendee-62',
    name: 'Michael Davis',
    role: 'Head of Product',
    company: 'Enhance Fitness',
    interests: ['Fitness', 'Wellness'],
    profileImage: 'https://i.pravatar.cc/150?img=3',
    email: 'michael.davis@enhancefitness.com',
    source: 'exhibitor',
    matchScore: 71,
  },
  {
    id: 'attendee-63',
    name: 'Emma Rodriguez',
    role: 'Head of Sales',
    company: 'Anytime Fitness',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=4',
    email: 'emma.rodriguez@anytimefitness.com',
    source: 'exhibitor',
    matchScore: 70,
  },
  {
    id: 'attendee-64',
    name: 'James Martinez',
    role: 'Head of Marketing',
    company: 'Matrix Fitness',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=5',
    email: 'james.martinez@matrixfitness.com',
    source: 'exhibitor',
    matchScore: 69,
  },
  {
    id: 'attendee-65',
    name: 'Olivia Hernandez',
    role: 'Head of Operations',
    company: 'Technogym',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=6',
    email: 'olivia.hernandez@technogym.com',
    source: 'exhibitor',
    matchScore: 68,
  },
  {
    id: 'attendee-66',
    name: 'David Lopez',
    role: 'Head of Product',
    company: 'MyProtein',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=7',
    email: 'david.lopez@myprotein.com',
    source: 'exhibitor',
    matchScore: 67,
  },
  {
    id: 'attendee-67',
    name: 'Sophia Gonzalez',
    role: 'Head of Sales',
    company: 'Optimum Nutrition',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=8',
    email: 'sophia.gonzalez@optimumnutrition.com',
    source: 'exhibitor',
    matchScore: 66,
  },
  {
    id: 'attendee-68',
    name: 'John Wilson',
    role: 'Head of Marketing',
    company: 'Lululemon',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=9',
    email: 'john.wilson@lululemon.com',
    source: 'exhibitor',
    matchScore: 65,
  },
  {
    id: 'attendee-69',
    name: 'Isabella Anderson',
    role: 'Head of Operations',
    company: 'Nike',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=10',
    email: 'isabella.anderson@nike.com',
    source: 'exhibitor',
    matchScore: 64,
  },
  {
    id: 'attendee-70',
    name: 'Robert Thomas',
    role: 'Head of Product',
    company: 'Fitness First',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=11',
    email: 'robert.thomas@fitnessfirst.com',
    source: 'exhibitor',
    matchScore: 63,
  },
  {
    id: 'attendee-71',
    name: 'Mia Taylor',
    role: 'Head of Sales',
    company: 'GymNation',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=12',
    email: 'mia.taylor@gymnation.com',
    source: 'exhibitor',
    matchScore: 62,
  },

  // Manager tier (22 attendees)
  {
    id: 'attendee-72',
    name: 'William Moore',
    role: 'Sales Manager',
    company: 'Enhance Fitness',
    interests: ['Fitness', 'Wellness'],
    profileImage: 'https://i.pravatar.cc/150?img=13',
    email: 'william.moore@enhancefitness.com',
    source: 'exhibitor',
    matchScore: 61,
  },
  {
    id: 'attendee-73',
    name: 'Charlotte Jackson',
    role: 'Marketing Manager',
    company: 'Anytime Fitness',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=14',
    email: 'charlotte.jackson@anytimefitness.com',
    source: 'exhibitor',
    matchScore: 60,
  },
  {
    id: 'attendee-74',
    name: 'Thomas Martin',
    role: 'Operations Manager',
    company: 'Matrix Fitness',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=15',
    email: 'thomas.martin@matrixfitness.com',
    source: 'exhibitor',
    matchScore: 59,
  },
  {
    id: 'attendee-75',
    name: 'Amelia Lee',
    role: 'Business Development Manager',
    company: 'Technogym',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=16',
    email: 'amelia.lee@technogym.com',
    source: 'exhibitor',
    matchScore: 58,
  },
  {
    id: 'attendee-76',
    name: 'Daniel Thompson',
    role: 'Product Manager',
    company: 'MyProtein',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=17',
    email: 'daniel.thompson@myprotein.com',
    source: 'exhibitor',
    matchScore: 57,
  },
  {
    id: 'attendee-77',
    name: 'Emily White',
    role: 'Regional Manager',
    company: 'Optimum Nutrition',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=18',
    email: 'emily.white@optimumnutrition.com',
    source: 'exhibitor',
    matchScore: 56,
  },
  {
    id: 'attendee-78',
    name: 'Matthew Harris',
    role: 'Senior Account Manager',
    company: 'Lululemon',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=19',
    email: 'matthew.harris@lululemon.com',
    source: 'exhibitor',
    matchScore: 55,
  },
  {
    id: 'attendee-79',
    name: 'Ava Clark',
    role: 'Sales Manager',
    company: 'Nike',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=20',
    email: 'ava.clark@nike.com',
    source: 'exhibitor',
    matchScore: 54,
  },
  {
    id: 'attendee-80',
    name: 'Christopher Lewis',
    role: 'Marketing Manager',
    company: 'Fitness First',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=1',
    email: 'christopher.lewis@fitnessfirst.com',
    source: 'exhibitor',
    matchScore: 53,
  },
  {
    id: 'attendee-81',
    name: 'Lily Robinson',
    role: 'Operations Manager',
    company: 'GymNation',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=2',
    email: 'lily.robinson@gymnation.com',
    source: 'exhibitor',
    matchScore: 52,
  },
  {
    id: 'attendee-82',
    name: 'Andrew Walker',
    role: 'Business Development Manager',
    company: 'Enhance Fitness',
    interests: ['Fitness', 'Wellness'],
    profileImage: 'https://i.pravatar.cc/150?img=3',
    email: 'andrew.walker@enhancefitness.com',
    source: 'exhibitor',
    matchScore: 51,
  },
  {
    id: 'attendee-83',
    name: 'Grace Young',
    role: 'Product Manager',
    company: 'Anytime Fitness',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=4',
    email: 'grace.young@anytimefitness.com',
    source: 'exhibitor',
    matchScore: 50,
  },
  {
    id: 'attendee-84',
    name: 'Joseph Allen',
    role: 'Regional Manager',
    company: 'Matrix Fitness',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=5',
    email: 'joseph.allen@matrixfitness.com',
    source: 'exhibitor',
    matchScore: 49,
  },
  {
    id: 'attendee-85',
    name: 'Chloe King',
    role: 'Senior Account Manager',
    company: 'Technogym',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=6',
    email: 'chloe.king@technogym.com',
    source: 'exhibitor',
    matchScore: 48,
  },
  {
    id: 'attendee-86',
    name: 'Ryan Wright',
    role: 'Sales Manager',
    company: 'MyProtein',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=7',
    email: 'ryan.wright@myprotein.com',
    source: 'exhibitor',
    matchScore: 47,
  },
  {
    id: 'attendee-87',
    name: 'Zoe Scott',
    role: 'Marketing Manager',
    company: 'Optimum Nutrition',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=8',
    email: 'zoe.scott@optimumnutrition.com',
    source: 'exhibitor',
    matchScore: 46,
  },
  {
    id: 'attendee-88',
    name: 'Alexander Torres',
    role: 'Operations Manager',
    company: 'Lululemon',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=9',
    email: 'alexander.torres@lululemon.com',
    source: 'exhibitor',
    matchScore: 45,
  },
  {
    id: 'attendee-89',
    name: 'Hannah Nguyen',
    role: 'Business Development Manager',
    company: 'Nike',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=10',
    email: 'hannah.nguyen@nike.com',
    source: 'exhibitor',
    matchScore: 44,
  },
  {
    id: 'attendee-90',
    name: 'Benjamin Hill',
    role: 'Product Manager',
    company: 'Fitness First',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=11',
    email: 'benjamin.hill@fitnessfirst.com',
    source: 'exhibitor',
    matchScore: 43,
  },
  {
    id: 'attendee-91',
    name: 'Sophie Flores',
    role: 'Regional Manager',
    company: 'GymNation',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=12',
    email: 'sophie.flores@gymnation.com',
    source: 'exhibitor',
    matchScore: 42,
  },
  {
    id: 'attendee-92',
    name: 'Jack Green',
    role: 'Senior Account Manager',
    company: 'Enhance Fitness',
    interests: ['Fitness', 'Wellness'],
    profileImage: 'https://i.pravatar.cc/150?img=13',
    email: 'jack.green@enhancefitness.com',
    source: 'exhibitor',
    matchScore: 41,
  },
  {
    id: 'attendee-93',
    name: 'Lucy Adams',
    role: 'Sales Manager',
    company: 'Anytime Fitness',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=14',
    email: 'lucy.adams@anytimefitness.com',
    source: 'exhibitor',
    matchScore: 40,
  },

  // Executive tier (16 attendees)
  {
    id: 'attendee-94',
    name: 'Oliver Nelson',
    role: 'Sales Executive',
    company: 'Matrix Fitness',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=15',
    email: 'oliver.nelson@matrixfitness.com',
    source: 'exhibitor',
    matchScore: 78,
  },
  {
    id: 'attendee-95',
    name: 'Ella Baker',
    role: 'Marketing Executive',
    company: 'Technogym',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=16',
    email: 'ella.baker@technogym.com',
    source: 'exhibitor',
    matchScore: 77,
  },
  {
    id: 'attendee-96',
    name: 'Henry Hall',
    role: 'Business Development Executive',
    company: 'MyProtein',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=17',
    email: 'henry.hall@myprotein.com',
    source: 'exhibitor',
    matchScore: 76,
  },
  {
    id: 'attendee-97',
    name: 'Megan Rivera',
    role: 'Account Executive',
    company: 'Optimum Nutrition',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=18',
    email: 'megan.rivera@optimumnutrition.com',
    source: 'exhibitor',
    matchScore: 75,
  },
  {
    id: 'attendee-98',
    name: 'Samuel Campbell',
    role: 'Product Specialist',
    company: 'Lululemon',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=19',
    email: 'samuel.campbell@lululemon.com',
    source: 'exhibitor',
    matchScore: 74,
  },
  {
    id: 'attendee-99',
    name: 'Natalie Mitchell',
    role: 'Brand Manager',
    company: 'Nike',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=20',
    email: 'natalie.mitchell@nike.com',
    source: 'exhibitor',
    matchScore: 73,
  },
  {
    id: 'attendee-100',
    name: 'Lucas Carter',
    role: 'Sales Coordinator',
    company: 'Fitness First',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=1',
    email: 'lucas.carter@fitnessfirst.com',
    source: 'exhibitor',
    matchScore: 72,
  },
  {
    id: 'attendee-101',
    name: 'Victoria Roberts',
    role: 'Marketing Coordinator',
    company: 'GymNation',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=2',
    email: 'victoria.roberts@gymnation.com',
    source: 'exhibitor',
    matchScore: 71,
  },
  {
    id: 'attendee-102',
    name: 'Ethan Al-Mansoori',
    role: 'Business Consultant',
    company: 'Enhance Fitness',
    interests: ['Fitness', 'Wellness'],
    profileImage: 'https://i.pravatar.cc/150?img=3',
    email: 'ethan.almansoori@enhancefitness.com',
    source: 'exhibitor',
    matchScore: 70,
  },
  {
    id: 'attendee-103',
    name: 'Rachel Al-Hashemi',
    role: 'Sales Executive',
    company: 'Anytime Fitness',
    interests: ['Fitness', 'Gym'],
    profileImage: 'https://i.pravatar.cc/150?img=4',
    email: 'rachel.alhashemi@anytimefitness.com',
    source: 'exhibitor',
    matchScore: 69,
  },
  {
    id: 'attendee-104',
    name: 'Nathan Al-Zaabi',
    role: 'Marketing Executive',
    company: 'Matrix Fitness',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=5',
    email: 'nathan.alzaabi@matrixfitness.com',
    source: 'exhibitor',
    matchScore: 68,
  },
  {
    id: 'attendee-105',
    name: 'Lauren Khan',
    role: 'Business Development Executive',
    company: 'Technogym',
    interests: ['Equipment', 'Technology'],
    profileImage: 'https://i.pravatar.cc/150?img=6',
    email: 'lauren.khan@technogym.com',
    source: 'exhibitor',
    matchScore: 67,
  },
  {
    id: 'attendee-106',
    name: 'Adam Patel',
    role: 'Account Executive',
    company: 'MyProtein',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=7',
    email: 'adam.patel@myprotein.com',
    source: 'exhibitor',
    matchScore: 66,
  },
  {
    id: 'attendee-107',
    name: 'Jessica Singh',
    role: 'Product Specialist',
    company: 'Optimum Nutrition',
    interests: ['Nutrition', 'Supplement'],
    profileImage: 'https://i.pravatar.cc/150?img=8',
    email: 'jessica.singh@optimumnutrition.com',
    source: 'exhibitor',
    matchScore: 65,
  },
  {
    id: 'attendee-108',
    name: 'Dylan Chen',
    role: 'Brand Manager',
    company: 'Lululemon',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=9',
    email: 'dylan.chen@lululemon.com',
    source: 'exhibitor',
    matchScore: 64,
  },
  {
    id: 'attendee-109',
    name: 'Rebecca Wang',
    role: 'Sales Coordinator',
    company: 'Nike',
    interests: ['Apparel', 'Fitness'],
    profileImage: 'https://i.pravatar.cc/150?img=10',
    email: 'rebecca.wang@nike.com',
    source: 'exhibitor',
    matchScore: 63,
  },
]
